import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const assetUrl = (p) => (p && p.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${p}` : p);

export const Brand = ({ to = "/" }) => {
  const { config } = useAuth();
  const logo = assetUrl(config?.branding?.logo_url);
  return (
    <Link to={to} className="flex items-center gap-2.5 group max-lg:min-h-[44px]" data-testid="brand-logo-link">
      {logo ? (
        <img src={logo} alt="Logo" className="h-9 w-auto max-w-[96px] object-contain" data-testid="brand-logo-image" />
      ) : (
        <span className="h-9 w-9 rounded-lg bg-[#0078D4] text-white grid place-items-center font-mono font-bold text-lg transition-transform duration-300 group-hover:-rotate-6">₹</span>
      )}
      <span className="leading-tight">
        <span className="block font-display font-extrabold tracking-tight text-slate-900 text-[15px]">
          WhatIsMyNetworth<span className="text-[#0078D4]">.in</span>
        </span>
        <span className="block text-[11px] text-slate-500">by Grow Up Once Again</span>
      </span>
    </Link>
  );
};

const LINKS = [["/how-it-works", "How it works"], ["/privacy", "Privacy"], ["/terms", "Terms"], ["/disclaimer", "Disclaimer"]];

export const Disclaimer = () => {
  const { config } = useAuth();
  const b = config?.branding || {};
  const details = [b.address, b.gstin && `GSTIN: ${b.gstin}`, b.registration, b.phone, b.email].filter(Boolean);
  return (
    <footer className="border-t border-slate-200 bg-white pb-[env(safe-area-inset-bottom)]" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid md:grid-cols-12 gap-6 text-xs text-slate-500">
        <div className="md:col-span-7 space-y-1.5">
          <p className="text-sm font-semibold text-slate-800" data-testid="footer-company-name">{b.company_name}</p>
          <p>WhatIsMyNetworth.in is part of the {b.brand_name || "Grow Up Once Again"} ecosystem.</p>
          {details.length > 0 && <p data-testid="footer-company-details">{details.join(" · ")}</p>}
          <p>For your information only. This is not financial advice.</p>
        </div>
        <nav className="md:col-span-5 flex flex-wrap md:justify-end gap-x-5 gap-y-2" data-testid="footer-links">
          {LINKS.map(([to, l]) => <Link key={to} to={to} className="hover:text-[#005A9E] max-lg:py-3 max-lg:text-sm" data-testid={`footer-link-${to.slice(1)}`}>{l}</Link>)}
        </nav>
      </div>
    </footer>
  );
};
